import type { FC } from 'react';
import React from 'react';
import { Body, Flex, DateTime, Box } from '@edreamsodigeo/prisma-design-system';

import DateTimeCapitalize from './DateTimeCapitalize';
import type { SectionFragment } from '@/generated/graphql';

interface SectionDateTimeMapItineraryProps {
  dateTime: SectionFragment['arrivalDate'];
}

const SectionDateTimeMapItinerary: FC<SectionDateTimeMapItineraryProps> = ({
  dateTime,
}) => {
  return (
    <Flex flexDirection="column" alignItems="flex-end">
      <Body type="base" weight="medium" sx={{ fontSize: '18px' }}>
        <DateTime type="time" value={dateTime} pattern="short" />
      </Body>
      <Box>
        <DateTimeCapitalize
          bodyType="xSmall"
          bodyColor="neutral.80"
          date={dateTime}
        />
      </Box>
    </Flex>
  );
};
export default SectionDateTimeMapItinerary;
